import React, { useEffect, useState } from "react";
import ContactImage from '../../assets/contact.png';
import { TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import axios from 'axios';

const Contact = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [courses, setCourses] = useState([]);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    service: '',
    message: ''
  });

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          "https://training.megascale.co.in/backend/get_courses.php"
        );
        console.log("Fetched Courses:", response.data); // ✅ Debugging log
        setCourses(response.data.courses || []); // ✅ Ensure courses is not undefined
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value || ""
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);

    const requestData = new FormData();
    requestData.append("first_name", formData.first_name);
    requestData.append("last_name", formData.last_name);
    requestData.append("email", formData.email);
    requestData.append("phone_number", formData.phone_number);
    requestData.append("service", formData.service);
    requestData.append("message", formData.message);

    axios.post('https://training.megascale.co.in/backend/save_form.php', requestData)
      .then((response) => {
        // alert('Form submitted successfully');
        console.log("Backend Response:", response.data);

        // Set success message
        setSuccessMessage('Your message has been successfully submitted! We will get back to you soon.');

        // Reset the form fields
        setFormData({
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          service: '',
          message: ''
        });

        // Clear the success message after 5 seconds (optional)
        setTimeout(() => {
          setSuccessMessage('');
        }, 5000);
      })
      .catch((error) => {
        console.error("Form Submission Error:", error);
        alert('There was an error submitting the form');
      });
  };


  return (
    <section className="bg-white p-6 pt-44">
      <div className="container   ">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 ">
          {/* Left Column */}
          <div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-blue-700 md:pt-0 pt-20 ">
              <span className="block text-center  relative">Contact Us Today</span>
            </h1>
            <div>
              <img
                src={ContactImage}
                alt="Contact"
                className="w-full h-auto "
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="mb-8">
            <p className="text-base sm:text-lg text-gray-700 font-semibold mb-4">
              Join us on your learning journey! Feel free to reach out and complete the form to take the first step toward your future.
            </p>
            <form
              onSubmit={handleSubmit}
              className="space-y-6 border-2 border-blue-100 p-6 sm:p-8 lg:p-10 bg-blue-100 rounded-lg"
            >
              {successMessage && (
                <div className="bg-green-200 text-green-700 p-4 mb-6 rounded-lg text-center">
                  {successMessage}
                </div>
              )}

              <div className="flex flex-col sm:flex-row gap-4">
                <TextField
                  id="first_name"
                  label="First Name"
                  variant="standard"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  className="w-full sm:w-1/2 mb-4"
                  placeholder="Enter your name"
                  required
                  InputLabelProps={{
                    style: { color: 'blue' }, // Change label color
                  }}
                />
                <TextField
                  id="last_name"
                  label="Last Name"
                  variant="standard"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  className="w-full sm:w-1/2 mb-4"
                  placeholder="Enter your name"
                  required
                  InputLabelProps={{
                    style: { color: 'blue' }, // Change label color
                  }}
                />
              </div>

              <div>
                <TextField
                  id="email"
                  label="Email"
                  variant="standard"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  className="mb-4"
                  placeholder="Enter your email"
                  required
                  InputLabelProps={{
                    style: { color: 'blue' }, // Change label color
                  }}
                />
              </div>
              <div>
                <TextField
                  id="phone_number"
                  label="Phone Number"
                  variant="standard"
                  name="phone_number"
                  value={formData.phone_number}
                  onChange={handleChange}
                  fullWidth
                  className="mb-4"
                  placeholder="Enter your phone number"
                  required
                  InputLabelProps={{
                    style: { color: 'blue' }, // Change label color
                  }}
                />
              </div>
              <div>
                <FormControl fullWidth className="mb-4">
                  <InputLabel
                    id="select-service-label"
                    style={{ color: 'blue' }}
                  >
                    Select Service
                  </InputLabel>
                  <Select
                    labelId="select-service-label"
                    id="select_service"
                    variant="standard"
                    name="service"
                    value={formData.service || ""}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value="">Select Service</MenuItem>
                    {courses.map((course) => (
                      <MenuItem key={course.id} value={course.title}>
                        {course.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div>
              </div>

              <div>
                <TextField
                  id="message"
                  label="Message"
                  variant="standard"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  fullWidth
                  className="mb-4"
                  placeholder="Enter your message"
                  multiline
                  rows={4}
                  required
                  InputLabelProps={{
                    style: { color: 'blue' }, // Change label color
                  }}
                />
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-indigo-600 to-blue-600 text-white py-3 px-4 rounded-md hover:from-indigo-700 hover:to-blue-700 transition duration-300 shadow-md"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>

  );
};

export default Contact;
